import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APP_ROUTES } from '@modeso/aumico-lib-core-fe';
import { environment } from '../environments/environment';
import { Paths } from './enums/paths.enum';
import { LogoutPage } from './pages/login/logout.page';
import { NotFoundPage } from './pages/not-found/not-found.page';
import { OAuthAuthorizePage } from './pages/oauth-authorize/oauth-authorize.page';
import { AuthGuard } from './shared/auth.guard';
import { DesignModeGuard } from './shared/design-mode.guard';
import { NoAuthGuard } from './shared/noauth.guard';

// Use environment default instead of localStorage at module level
const defaultLanguage = environment.defaultLanguage;

const routes: Routes = [
    {
        path: `${Paths.DESIGN}`,
        loadChildren: () => import('./modules/design/design.module').then((m) => m.DesignModule),
        canLoad: [DesignModeGuard],
    },
    {
        path: `${Paths.EMAIL_VERIFICATION}`,
        redirectTo: `${defaultLanguage}/${Paths.AUTH}/${Paths.EMAIL_VERIFICATION}`,
    },
    {
        path: `${Paths.PASSWORD_RESET}`,
        redirectTo: `${defaultLanguage}/${Paths.AUTH}/${Paths.PASSWORD_RESET}`,
    },
    {
        path: `${Paths.INVITATION}`,
        redirectTo: `${defaultLanguage}/${Paths.AUTH}/${Paths.INVITATION}`,
    },
    {
        path: `${Paths.SIGNUP}`,
        redirectTo: `${defaultLanguage}/${Paths.AUTH}/${Paths.SIGNUP}`,
    },
    {
        path: `${Paths.NOT_FOUND}`,
        component: NotFoundPage,
    },
    {
        // §2 steps 3–4 (REV-21656). Deliberately guard-free: the page routes a
        // signed-out user through login itself, carrying the full request as
        // returnUrl. Must stay above the `:language` and `**` matchers.
        path: 'oauth/authorize',
        component: OAuthAuthorizePage,
    },
    {
        path: `:language/${Paths.AUTH}`,
        loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
        canActivate: [NoAuthGuard],
    },
    {
        path: `:language/${Paths.HOME}`,
        loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
        canActivate: [AuthGuard],
        data: {
            canSeeNavigationLinkRoles: ['AnnualReportUser'],
        },
    },
    {
        path: `:language/${Paths.LOGOUT}`,
        component: LogoutPage,
        data: {
            label: 'aumico_reports_main_navigation_logout',
            canSeeNavigationLinkRoles: ['AnnualReportUser'],
        },
    },
    {
        path: `:language`,
        redirectTo: `:language/${Paths.AUTH}/${Paths.LOGIN}`,
        pathMatch: 'full',
    },
    {
        path: '',
        redirectTo: `${defaultLanguage}/${Paths.AUTH}/${Paths.LOGIN}`,
        pathMatch: 'full',
    },
    {
        path: '**',
        redirectTo: `${defaultLanguage}/${Paths.AUTH}/${Paths.LOGIN}`,
        pathMatch: 'full',
    },
];

export const APP_ROUTES_CONFIG: Routes = routes;
@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule],
    providers: [{ provide: APP_ROUTES, useValue: APP_ROUTES_CONFIG }],
})
export class AppRoutingModule {}
